import Footer from "./footer";
import About from "./about";

function AboutPage(){
    return(
        <> 
        <About/>
         <Footer/>
        </>
    );
}
export default AboutPage;